// src/Models/ticketStatusModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class TicketStatusModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      statusID: data.statusId || data.statusID || 0,
      projectID: data.projectId || data.projectID || 0,
      statusName: data.statusName || '',
      sequenceOrder: data.sequenceOrder || 0,
      isClosedStatusFlag: data.isClosedStatusFlag !== undefined ? data.isClosedStatusFlag : false,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      statusId: Number(data.statusID || data.statusId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      statusName: data.statusName || '',
      sequenceOrder: Number(data.sequenceOrder || 0),
      isClosedStatusFlag: data.isClosedStatusFlag === true || data.isClosedStatusFlag === 'true' || data.isClosedStatusFlag === 1,
    };
  }
}
